/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing(
  $routeProvider: RouteProvider,
): void {
  const FormTemplate = require('./user-form/user-form.template.html');

  $routeProvider
    .when('/settings/users/table', {
      templateUrl: require('./user-table/user-table.template.html'),
      title: 'Benutzer verwalten',
    })
    .when('/settings/users/edit/:userid', {
      templateUrl: FormTemplate,
      title: 'Benutzer bearbeiten',
    })
    .when('/settings/users/add', {
      templateUrl: FormTemplate,
      title: 'Benutzer anlegen',
    });
}
